import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

export function Divider({ style, inset }: { style?: ViewStyle; inset?: boolean }) {
  const { colors } = useAppTheme();
  return <View style={[styles.line, { backgroundColor: colors.border }, inset && styles.inset, style]} />;
}

const styles = ScaledSheet.create({
  line: { height: StyleSheet.hairlineWidth, width: '100%' },
  inset: { marginLeft: 16 },
});
